import { UploadClient } from "@welearn/upload-client";
import { httpClient } from "./httpClient";
export type GiftInput = {
  name: string;
  description: string;
  price_cent: number;
  sort_order: number;
  status: "active" | "inactive";
  image_id: string;
  version: number;
};
export type Gift = GiftInput & { public_id: string; image_url: string };
export const giftUploads = new UploadClient({
  request: <T>(path: string, init: RequestInit = {}) =>
    httpClient.request<T>(path, init),
  concurrency: 3,
  base: "/admin/gift-images",
});
export const giftGateway = {
  listBuiltinGiftImages: (signal?: AbortSignal) => httpClient.get<{ id: string; name: string; url: string }[]>("/admin/gift-images/builtin", signal),
  listGifts: (signal?: AbortSignal) => httpClient.get<Gift[]>("/admin/gifts", signal),
  saveGift: (id: string | undefined, input: GiftInput) =>
    id
      ? httpClient.put<Gift>(`/admin/gifts/${encodeURIComponent(id)}`, input)
      : httpClient.post<Gift>("/admin/gifts", input),
  deleteGift: (id: string, input: {version: number; reason: string}) =>
    httpClient.request<{deleted: boolean}>(`/admin/gifts/${encodeURIComponent(id)}`, {method: "DELETE", body: JSON.stringify(input)}),
  giftImageStatus: (id: string, signal?: AbortSignal) =>
    httpClient.get<{ status: string; scan_status: string }>(
      `/admin/gift-images/${encodeURIComponent(id)}`, signal
    ),
  giftImageAccess: (id: string, signal?: AbortSignal) =>
    httpClient.post<{ preview_url: string }>(
      `/admin/gift-images/${encodeURIComponent(id)}/access`, undefined, signal
    ),
};
